import React from 'react';
import {CommonEdit} from '../Common';
import {getInputs} from './Common';

export const ContractEdit = props => <CommonEdit {...props} fields={getInputs()} />;
